export default __webpack_public_path__ + "static/media/cloud.95b30b67.svg";